import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosResponse } from "axios";

import api from "@/common/utils/api";
import { AdminCreateOrgType } from "@reflag/shared/adminAPI";
import { ErrorResponse } from "@reflag/shared/api";
import { Org } from "@reflag/shared/organizationAPI";

export function useAdminOrgCreateMutation() {
  const queryClient = useQueryClient();

  return useMutation<Org, AxiosResponse<ErrorResponse>, AdminCreateOrgType>({
    mutationKey: ["admin", "org"],
    mutationFn: (body) =>
      api.post<"/admin">("/admin", body).then((res) => res.data),
    onSuccess() {
      queryClient.invalidateQueries({
        queryKey: ["orgs"],
      });
    },
  });
}
